<template>
  <div>
    <v-alert v-if="error" type="error">{{ error }}</v-alert>

    <v-alert :type="party.techniciansOnly ? 'success' : 'info'" :icon="false">
      <div class="d-flex align-center gap-2 justify-space-between">
        <div>
          Permitir gerenciamento apenas por técnicos?
          <small class="text-caption d-block">
            Com essa opção, apenas técnicos da plataforma poderão gerenciar os
            detalhes e configurações de venda do evento
          </small>
          <v-tooltip top>
            <template v-slot:activator="{ props, on }">
              <small v-bind="props" v-on="on" class="align-center gap-1">
                <v-icon x-small>mdi-information-outline</v-icon>
                Essa opção não afeta todas as funções
              </small>
            </template>
            <span> Não afeta o faq, galeria, cortesia e reembolso </span>
          </v-tooltip>
        </div>
        <v-switch
          v-model="party.techniciansOnly"
          class="mt-0 mb-0"
          hide-details
          color="primary"
          :loading="loadingTechniciansOnly"
          :disabled="loadingTechniciansOnly"
        />
      </div>
    </v-alert>

    <div class="mt-6" outlined>
      <div class="d-flex align-center gap-2 justify-space-between mb-1">
        <h6 class="mb-0">Técnicos no evento</h6>
        <v-btn
          @click="addTechnician"
          color="primary"
          x-small
          :disabled="loading"
        >
          <v-icon x-small>mdi-plus</v-icon>
          técnico
        </v-btn>
      </div>
      <p>
        Caso tenha técnicos atribuídos, durante o evento, apenas eles poderão
        gerenciar as configurações de entrada e bilheteria
      </p>

      <v-alert v-if="technicians.length === 0" type="info" class="mb-0">
        Nenhum técnico atribuído
      </v-alert>
      <v-list v-else dense>
        <v-list-item v-for="technician in technicians" :key="technician.id">
          <v-list-item-avatar>
            <base-avatar
              :src="technician.User.photo"
              :seed="technician.User.id"
              :size="32"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ technician.User.name || "Conta não criada" }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ technician.User.phone }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="removeTechnician(technician.User.id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </div>
    <PartyTechnicianModal
      :technicians="technicians"
      :party="party"
      @success="getTechnicians"
    />
  </div>
</template>

<script>
import moment from "moment";
import PARTY from "@/services/admin/parties";
import PartyTechnicianModal from "./modules/PartyTechnicianModal.vue";

export default {
  name: "PartyTechnicians",
  components: {
    PartyTechnicianModal,
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingTechniciansOnly: false,
      loading: true,
      error: null,
      technicians: [],
    };
  },
  methods: {
    async saveTechniciansOnly() {
      this.loadingTechniciansOnly = true;
      this.error = null;
      try {
        await PARTY.update(this.party.id, {
          techniciansOnly: this.party.techniciansOnly,
        });
      } catch (error) {
        console.error("Erro ao buscar técnicos:", error);
        this.error = error.message;
      } finally {
        this.loadingTechniciansOnly = false;
      }
    },
    async getTechnicians() {
      this.loading = true;
      this.error = null;
      try {
        const data = await PARTY.getTechnicians(this.party.id);
        this.technicians = data.technicians;
      } catch (error) {
        console.error("Erro ao buscar técnicos:", error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    async removeTechnician(technicianId) {
      this.loadingRemove = technicianId;
      try {
        const confirm = window.confirm(
          "Tem certeza que deseja remover o técnico desse evento?"
        );
        if (!confirm) return;
        await PARTY.removeTechnician(this.party.id, technicianId);
        this.getTechnicians();
      } catch (error) {
        console.error("Erro ao remover técnico:", error);
        this.error = error.message;
      } finally {
        this.loadingRemove = false;
      }
    },
    addTechnician() {
      this.$root.$emit("add-party-technician");
    },
  },
  watch: {
    "party.techniciansOnly": {
      handler() {
        this.saveTechniciansOnly();
      },
    },
  },
  mounted() {
    this.getTechnicians();
  },
};
</script>
